import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckMark = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 17,
	fill: "none",
	"xmlns:v": "https://vecta.io/nano",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#A)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M14.857 2.987L5.623 12.22a.67.67 0 0 1-.473.197.67.67 0 0 1-.473-.197L1.105 8.646a.67.67 0 0 0-.473-.197.67.67 0 0 0-.473.197.67.67 0 0 0-.197.473.67.67 0 0 0 .197.473l3.572 3.572a2.01 2.01 0 0 0 2.84 0l9.233-9.231A.67.67 0 0 0 16 3.46a.67.67 0 0 0-.196-.473.67.67 0 0 0-.473-.197.67.67 0 0 0-.473.197z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "A",
		children: /* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			transform: "translate(0 .5)",
			d: "M0 0h16v16H0z"
		})
	}) })]
});
export default SvgCheckMark;
